import { APP_NAME } from "@/lib/brand";
import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Folder, ChevronLeft } from "lucide-react";

export const FolderPicker = ({ onPick, onClose }) => {
  const [path, setPath] = useState("");
  const [folders, setFolders] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    setError("");
    api.get("/admin/backup/folders", { params: { path } }).then((r) => setFolders(r.data.folders)).catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail)));
  }, [path]);

  const up = () => setPath(path.split("/").slice(0, -1).join("/"));

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="backup-folder-picker">
        <DialogHeader><DialogTitle>Select destination folder</DialogTitle></DialogHeader>
        <div className="flex items-center gap-2 text-xs font-mono text-slate-600">
          <Button size="sm" variant="ghost" onClick={up} disabled={!path} data-testid="folder-picker-up"><ChevronLeft className="h-4 w-4" /></Button>/{path}
        </div>
        {error && <p className="text-xs text-red-600" data-testid="folder-picker-error">{error}</p>}
        <div className="max-h-72 overflow-y-auto divide-y divide-slate-100 border border-slate-200 rounded-md">
          {folders.length === 0 && !error && <p className="p-3 text-xs text-slate-500">No sub-folders here.</p>}
          {folders.map((f) => (
            <button key={f.id} onClick={() => setPath(f.path)} className="w-full text-left px-3 py-2 text-sm flex items-center gap-2 hover:bg-slate-50" data-testid={`folder-picker-item-${f.name}`}><Folder className="h-4 w-4 text-amber-500" />{f.name}</button>
          ))}
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={() => onPick(path || APP_NAME)} disabled={!path} data-testid="folder-picker-select">Use this folder</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
